'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDataReloaded = exports.reloadUserSpecificData = exports.setSessionStorageItem = exports.setLocalStorageItem = exports.resetLDClientId = exports.setLDClientId = exports.bootstrapSuccess = exports.bootstrap = undefined;

var _actionTypes = require('./actionTypes');

var Types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var bootstrap = exports.bootstrap = function bootstrap() {
  return {
    type: Types.BOOTSTRAP
  };
};

var bootstrapSuccess = exports.bootstrapSuccess = function bootstrapSuccess() {
  return {
    type: Types.BOOTSTRAP_SUCCESS
  };
};

// set the clientId for launch darcly flags.
var setLDClientId = exports.setLDClientId = function setLDClientId(clientId) {
  return {
    type: Types.SET_LD_CLIENT_ID,
    clientId: clientId
  };
};

// destroy the clientId for launch darcly flags.
var resetLDClientId = exports.resetLDClientId = function resetLDClientId() {
  return {
    type: Types.RESET_LD_CLIENT_ID
  };
};

var setLocalStorageItem = exports.setLocalStorageItem = function setLocalStorageItem(key, value) {
  return {
    type: Types.SET_LOCAL_STORAGE_VALUE,
    key: key,
    value: value
  };
};

var setSessionStorageItem = exports.setSessionStorageItem = function setSessionStorageItem(key, value) {
  return {
    type: Types.SET_LOCAL_STORAGE_VALUE,
    key: key,
    value: value
  };
};

var reloadUserSpecificData = exports.reloadUserSpecificData = function reloadUserSpecificData(payload) {
  return {
    type: Types.RELOAD_USER_SPECIFIC_DATA,
    payload: payload
  };
};

var userDataReloaded = exports.userDataReloaded = function userDataReloaded(crossTabState, tabID) {
  return {
    type: Types.USER_DATA_RELOADED,
    crossTabState: crossTabState,
    tabID: tabID
  };
};